import React from 'react';
import PropTypes from 'prop-types';
import Props from './PhoneComponent';
import InsetWrapper from '@s/InsetWrapper';
import {TranslationContext} from "@c/Translations";

export const countryCodes = [
    "1",
    "7",
    "20",
    "27",
    "30",
    "31",
    "32",
    "33",
    "34",
    "36",
    "39",
    "40",
    "41",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "51",
    "52",
    "54",
    "55",
    "56",
    "57",
    "58",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "81",
    "82",
    "84",
    "86",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "98",
    "212",
    "213",
    "216",
    "218",
    "220",
    "221",
    "222",
    "223",
    "224",
    "225",
    "226",
    "227",
    "228",
    "229",
    "230",
    "231",
    "232",
    "233",
    "234",
    "235",
    "236",
    "237",
    "238",
    "240",
    "241",
    "242",
    "243",
    "244",
    "247",
    "248",
    "249",
    "250",
    "251",
    "252",
    "253",
    "254",
    "255",
    "256",
    "257",
    "258",
    "260",
    "261",
    "262",
    "263",
    "264",
    "265",
    "266",
    "267",
    "268",
    "269",
    "291",
    "297",
    "298",
    "299",
    "350",
    "351",
    "352",
    "353",
    "354",
    "355",
    "356",
    "357",
    "358",
    "359",
    "370",
    "371",
    "372",
    "373",
    "374",
    "375",
    "376",
    "377",
    "378",
    "379",
    "380",
    "381",
    "382",
    "385",
    "386",
    "387",
    "389",
    "420",
    "421",
    "423",
    "501",
    "502",
    "503",
    "504",
    "505",
    "506",
    "507",
    "508",
    "509",
    "590",
    "591",
    "592",
    "593",
    "594",
    "595",
    "596",
    "597",
    "598",
    "599",
    "673",
    "676",
    "679",
    "680",
    "685",
    "687",
    "688",
    "689",
    "691",
    "692",
    "850",
    "852",
    "853",
    "855",
    "856",
    "880",
    "883",
    "886",
    "960",
    "961",
    "962",
    "963",
    "964",
    "965",
    "966",
    "967",
    "968",
    "970",
    "971",
    "972",
    "973",
    "974",
    "975",
    "976",
    "977",
    "992",
    "993",
    "994",
    "995",
    "996",
    "998",
    "1246",
    "1264",
    "1268",
    "1284",
    "1340",
    "1345",
    "1441",
    "1473",
    "1649",
    "1664",
    "1670",
    "1671",
    "1684",
    "1758",
    "1767",
    "1784",
    "1787",
    "1809",
    "1868",
    "1869",
    "1876",
    "3491",
];

const Phone = props => {

    const translate = React.useContext(TranslationContext).t;

    const onPhoneChange = e => {
        props.onPhoneChange(e.target.value);
    }

    const onCountryCodeChange = e => {
        props.onCountryCodeChange(e.target.value);
    }

    const onFocus = e => {
        if(props.onFocus) {
            props.onFocus(e);
        }
    }

    return(
        <div className="input__phone">
            <div className="input__select">
                <select
                    className="input__control input__phone__country-code"
                    onChange={onCountryCodeChange}
                    value={props.countryCode}
                >
                    {countryCodes.map(code => (
                        <option key={code} value={code}>{`+${code}`}</option>
                    ))}
                </select>
                <i className="icon-keyboard_arrow_down" />
            </div>
            <InsetWrapper hasError={props.hasError}>
                <div className="input__top">
                    <label className="input__label" htmlFor="customerPhone">{translate('checkout__phone')}</label>
                    {!props.hideRequiredLabel && (
                        <span className="input__required">{translate(props.required ? 'checkout__required' : 'checkout__optional')}</span>
                    )}
                </div>
                <input
                    className="input__control"
                    type="tel"
                    placeholder={translate('checkout__phone')}
                    name="Phone"
                    value={props.phone}
                    onChange={onPhoneChange}
                    onFocus={onFocus}
                    onBlur={props.onBlur}
                    autoComplete={props.autocomplete ? "on" : "off"}
                />
            </InsetWrapper>
        </div>
    );

}

Phone.propTypes = {
    phone: PropTypes.string,
    countryCode: PropTypes.string,
    required: PropTypes.bool,
    onPhoneChange: PropTypes.func.isRequired,
    focus: PropTypes.bool,
    autocomplete: PropTypes.bool,
    hideRequiredLabel: PropTypes.bool
}

Phone.defaultProps = {
    focus: false,
    phone: '',
    autocomplete: true,
    hideRequiredLabel: false
}

export default Phone;
